import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';
import { UseQueryOverrideOptions } from '../common';
import { PractitionerSettings } from 'src/models';

type GetCurrentPractitionerSettingsResponse = PractitionerSettings;

export const useGetCurrentPractitionerSettings = (
  _unused?: unknown,
  options: UseQueryOverrideOptions<GetCurrentPractitionerSettingsResponse> = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['currentPractitionerSettings'],
    queryFn: () =>
      api
        .get<GetCurrentPractitionerSettingsResponse>('/self/settings')
        .then((res) => res.data),
  });
};
